import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DmsLoaderService {
  private readonly loading = signal(false);
  private readonly mainLoading = signal(false);
  private readonly message = signal('Please wait while we update the data.');

  readonly isLoading = this.loading.asReadonly();
  readonly isMainLoading = this.mainLoading.asReadonly();
  readonly loaderMessage = this.message.asReadonly();

  /**
   * Method for on the loader
   */
  loaderOn(message?: string): void {
    if (message) this.message.set(message);
    this.loading.set(true);
  }

  /**
   * Method for off the loader
   */
  loaderOff(): void {
    this.loading.set(false);
  }

  /**
   * Method for on the main loader
   */
  mainLoaderOn(message?: string): void {
    if (message) this.message.set(message);
    this.mainLoading.set(true);
  }

  /**
   * Method for off the main loader
   */
  mainLoaderOff(): void {
    this.mainLoading.set(false);
  }

  /**
   * Update loader message
   */
  setMessage(message: string): void {
    this.message.set(message);
  }
}
